import { useContext, useEffect, useState } from "react";
import { Store } from "../context/store";
import apiRequest from "./apiRequest";

export const useAuth = () => {
  const store = useContext(Store);

  const [baseUrl] = store.url;
  const [loggedInUser, setLoggedInUser] = store.loggedInUser;

  const [authInitialized, setAuthInitialized] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadUser = async () => {
      try {
        const token = localStorage.getItem("royal-token");

        if (!token) {
          setLoggedInUser(null);
          return;
        }

        const { data } = await apiRequest(
          `${baseUrl}/token`,
          "GET",
          null,
          token
        );

        setLoggedInUser(data);
      } catch (err) {
        setLoggedInUser(null);
        setError("Session expired");
        localStorage.removeItem("royal-token");
      } finally {
        setAuthInitialized(true);
      }
    };

    loadUser();
  }, [baseUrl, setLoggedInUser]);

  return {
    loggedInUser,
    authInitialized,
    error,
  };
};
